import { z } from "zod";
export const localeSchema = z.enum(["ru", "en"]);
export const DEFAULT_LOCALE = "ru";
export const LOCALES = ["ru", "en"];
export const LOCALE_LABELS = {
    ru: "Русский",
    en: "English",
};
/** Query param accepted by catalogue endpoints to localise free text. */
export const localeQuerySchema = z.object({
    lang: localeSchema.default(DEFAULT_LOCALE),
});
//# sourceMappingURL=locale.js.map